/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Filter1Icon from '@mui/icons-material/Filter1';
import PortraitIcon from '@mui/icons-material/Portrait';
import WorkIcon from '@mui/icons-material/Work';
import CategoryIcon from '@mui/icons-material/Category';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

export const exportTrainingAuthorizationPdf = {
  'Name': { halign: 'center', cellWidth: 50 },
  'Email': { halign: 'center', cellWidth: 65 },
  'Company': { halign: 'center', cellWidth: 65 },
  'Certification Name': { halign: 'left', cellWidth: 110 },
  'Course Name': { halign: 'center', cellWidth: 70 },
  'Product Model': { halign: 'left', cellWidth: 65 },
  'Date of Training': { halign: 'left', cellWidth: 65 },
  'Certified': { halign: 'left', cellWidth: 65 },
  'Active': { halign: 'left', cellWidth: 65 }
};

export const exportProductAuthorizationPdf = {
  'Company Name': { halign: 'center', cellWidth: 50 },
  'Product Model': { halign: 'center', cellWidth: 65 },
  'Product Name': { halign: 'center', cellWidth: 65 },
  'Product Family': { halign: 'center', cellWidth: 65 },
};

export const trainingSearchSuggestions = [
  {
    Icon: PortraitIcon,
    toolTip: 'Name',
    suffix: ' in Name',
    searchProp: 'name'
  },
  {
    Icon: MailOutlineIcon,
    toolTip: 'Email',
    suffix: ' in Email',
    searchProp: 'email'
  },
  {
    Icon: WorkIcon,
    toolTip: 'Company',
    suffix: ' in Company',
    searchProp: 'company'
  }, {
    Icon: CategoryIcon,
    toolTip: 'Product Model',
    suffix: ' in Product Model',
    searchProp: 'twodproductmodel'
  }, {
    Icon: LaptopChromebookIcon,
    toolTip: 'Course Name',
    suffix: ' in Course Name',
    searchProp: 'coursename'
  },
  {
    Icon: CardMembershipIcon,
    toolTip: 'Certification Name',
    suffix: ' in Certification Name',
    searchProp: 'certificationname'
  },
  {
    Icon: PlaylistAddCheckIcon,
    toolTip: 'Certified',
    suffix: ' in Certified',
    searchProp: 'iscertified'
  },
  {
    Icon: CheckCircleOutlineIcon,
    toolTip: 'Active',
    suffix: ' in Active',
    searchProp: 'isactive'
  },
];

export const productTrainingSearchSuggestions = [
  {
    Icon: WorkIcon,
    toolTip: 'Company',
    suffix: ' in Company',
    searchProp: 'companyname'
  },
  {
    Icon: CategoryIcon,
    toolTip: 'Product Model',
    suffix: ' in Product Model',
    searchProp: 'twodproductmodelname'
  },
  {
    Icon: DescriptionIcon,
    toolTip: 'Product Name',
    suffix: ' in Product Name',
    searchProp: 'twodproductname'
  }, {
    Icon: DescriptionIcon,
    toolTip: 'Product Family',
    suffix: ' in Product Family',
    searchProp: 'twodproductfamilyname'
  }
];
